export default {"src":"/_next/static/media/ic-additional-attributes.5ca19c14.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};